import { render, staticRenderFns } from "./CustomPageRoute.vue?vue&type=template&id=334d1e82&scoped=true"
import script from "./CustomPageRoute.vue?vue&type=script&lang=ts"
export * from "./CustomPageRoute.vue?vue&type=script&lang=ts"
import style0 from "./CustomPageRoute.vue?vue&type=style&index=0&id=334d1e82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d1e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('334d1e82')) {
      api.createRecord('334d1e82', component.options)
    } else {
      api.reload('334d1e82', component.options)
    }
    module.hot.accept("./CustomPageRoute.vue?vue&type=template&id=334d1e82&scoped=true", function () {
      api.rerender('334d1e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomPageRoute.vue"
export default component.exports